import { InteractionRequiredAuthError } from '@azure/msal-browser'

import { apiConfig, msalInstance } from '../authConfig'

export interface ApiAccessToken {
  accessToken: string
  /** Expiry in ms since epoch. */
  expiresOn: number
}

/** Access token for PmpApi, or null when nobody is signed in. Shared by apiClient and the live dashboards iframe. */
export async function getApiAccessToken({ forceRefresh = false } = {}): Promise<ApiAccessToken | null> {
  const account = msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0]
  if (!account) return null

  const request = { scopes: apiConfig.scopes, account, forceRefresh }
  const tokenResponse = await msalInstance.acquireTokenSilent(request).catch(async (error) => {
    if (error instanceof InteractionRequiredAuthError) {
      // Use popup instead of redirect to maintain user context
      return await msalInstance.acquireTokenPopup(request)
    }
    throw error
  })
  if (!tokenResponse) return null

  return { accessToken: tokenResponse.accessToken, expiresOn: tokenResponse.expiresOn?.getTime() ?? 0 }
}
